<ng-container [ngSwitch]="desktopTemplate">
    <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="xsmode"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="bigmode"></ng-container>
</ng-container>


<ng-template #xsmode>
    <div class="tmp_srchwrpmobile" #globalsearch="cdkOverlayOrigin" cdkOverlayOrigin>
        <input type="text" multilang deeplMode="placeholder"  class="tmpangebotsktvinputmobile" [formControl]="mySearchControl"
            placeholder="Reiseziel, Angebote" autocomplete="off" (keydown.enter)="gotoSearch($event)">

        <ng-container *ngIf="!loading else myloading">
            <button class="tmp_srchbtn" (click)="gotoSearch($event)" aria-label="Search" matRipple>
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="var(--cl-bg-color)">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
            </button>
        </ng-container>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="globalsearch"
        [cdkConnectedOverlayFlexibleDimensions]="true" (overlayOutsideClick)="showglobalsearchres = false"
        [cdkConnectedOverlayOpen]="showglobalsearchres">
        <div class="cc50wrappermobile">
            <ng-container *ngIf="searchres?.length > 0 else notfound">
                <div class="cc50mobile customscroll" (scroll)="$event.stopPropagation()">
                    <ng-container *ngFor="let obj of searchres">
                        <button class="cc50-itemmobile" (click)="gotofirst(obj, $event)">
                            <div class="cc51mobile">
                                <ng-container *ngIf="obj?.sktvbestellnummer?.length > 0">
                                    <div class="ccsjtv" multilang [innerHTML]="obj.sktvbestellnummer | safehtml"></div>
                                </ng-container>
                                <div class="cc50-title" [innerHTML]="obj.displayname | safehtml"></div>
                                <ng-container *ngIf="obj.subtext?.length > 0">
                                    <span multilang class="cc50-item-subtext">{{obj.subtext}}</span>
                                </ng-container>
                            </div>
                            <div class="cc52mobile">
                                <button class="cc53mobile" *ngIf="obj.isPauschal"
                                    (click)="gotoPauschal(obj, $event)">{{'Pauschal' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isHotelonly"
                                    (click)="gotoHotel(obj, $event)">{{'Hotel' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isRailtravel"
                                    (click)="gotoRail(obj, $event)">{{'Bahn' }}
                                    +
                                    {{'Hotel' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isFlight"
                                    (click)="gotoFlight(obj, $event)">{{'Flug' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isCarrent"
                                    (click)="gotoCarrent(obj, $event)">{{'Mietwagen' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isCruise"
                                    (click)="gotoCruise(obj, $event)">{{'Kreuzfahrten' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isFerienhauser"
                                    (click)="gotoFerienhauser(obj, $event)">{{'Ferienhäuser' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isContent"
                                    (click)="gotoContent(obj, $event)">{{'Travelfacts' }}</button>
                                <button class="cc53mobile" *ngIf="obj.isTvangebote"
                                    (click)="gotoSktv(obj, $event)">{{'TV-Angebote' }}</button>
                                @if(obj.isGolfplatz) {
                                <button class="cc53mobile" (click)="gotoGolfPlz(obj, $event)">{{'Golfplatz' }}</button>
                                }
                                @if(obj.isGolfHotels) {
                                <button class="cc53mobile" (click)="gotoGolfHotel(obj, $event)">{{'Golfhotel'
                                    }}</button>
                                }
                                @if(obj.isJtHotels) {
                                <button class="cc53mobile" (click)="gotoJtHotel(obj, $event)">{{'JT-Hotel' }}</button>
                                }
                            </div>
                        </button>
                    </ng-container>
                </div>
                <div class="cc50footer">
                    <button class="wbtn" (click)="gotoSearch($event)" matRipple>{{'weitere Ergebnisse anzeigen'
                        }}</button>
                </div>
            </ng-container>
        </div>
    </ng-template>
</ng-template>

<ng-template #bigmode>
    <div class="tmp_body">
        <div class="tmp_srchwrp" #globalsearch="cdkOverlayOrigin" cdkOverlayOrigin>
            <input type="text" class="tmpangebotsktvinput" autocomplete="off" [formControl]="mySearchControl"
                placeholder="Reiseziel, Angebote" multilang deeplMode="placeholder" (keydown.enter)="gotoSearch($event)">

            <ng-container *ngIf="!loading else myloading">
                <button class="tmp_srchbtn-big" (click)="gotoSearch($event)" aria-label="Search" matRipple>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                        fill="var(--cl-bg-color)">
                        <path d="M0 0h24v24H0z" fill="none" />
                        <path
                            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                    </svg>
                </button>
            </ng-container>
        </div>
    </div>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="globalsearch"
        [cdkConnectedOverlayFlexibleDimensions]="true" (overlayOutsideClick)="showglobalsearchres = false"
        [cdkConnectedOverlayOpen]="showglobalsearchres">
        <div class="cc50wrapper mat-elevation-z2">
            <ng-container *ngIf="searchres?.length > 0 else notfound">
                <div class="cc50 customscroll">
                    <ng-container *ngFor="let obj of searchres">
                        <button class="cc50-item" (click)="gotofirst(obj, $event)">
                            <div class="cc51">
                                <ng-container *ngIf="obj?.sktvbestellnummer?.length > 0">
                                    <div class="ccsjtv" multilang [innerHTML]="obj.sktvbestellnummer | safehtml"></div>
                                </ng-container>
                                <div class="cc50-title" [innerHTML]="obj.displayname | safehtml"></div>
                                <ng-container *ngIf="obj.subtext?.length > 0">
                                    <span multilang class="cc50-item-subtext">{{obj.subtext}}</span>
                                </ng-container>
                            </div>
                            <div class="cc52">
                                <button class="cc53" *ngIf="obj.isPauschal"
                                    (click)="gotoPauschal(obj, $event)">{{'Pauschal' }}</button>
                                <button class="cc53" *ngIf="obj.isHotelonly" (click)="gotoHotel(obj, $event)">{{'Hotel'
                                    }}</button>
                                <button class="cc53" *ngIf="obj.isRailtravel" (click)="gotoRail(obj, $event)">{{'Bahn'
                                    }} +
                                    {{'Hotel' }}</button>
                                <button class="cc53" *ngIf="obj.isFlight" (click)="gotoFlight(obj, $event)">{{'Flug'
                                    }}</button>
                                <button class="cc53" *ngIf="obj.isCarrent"
                                    (click)="gotoCarrent(obj, $event)">{{'Mietwagen' }}</button>
                                <button class="cc53" *ngIf="obj.isCruise"
                                    (click)="gotoCruise(obj, $event)">{{'Kreuzfahrten' }}</button>
                                <button class="cc53" *ngIf="obj.isFerienhauser"
                                    (click)="gotoFerienhauser(obj, $event)">{{'Ferienhäuser' }}</button>
                                <button class="cc53" *ngIf="obj.isContent"
                                    (click)="gotoContent(obj, $event)">{{'Travelfacts' }}</button>
                                <button class="cc53" *ngIf="obj.isTvangebote"
                                    (click)="gotoSktv(obj, $event)">{{'TV-Angebote' }}</button>
                                @if(obj.isGolfplatz) {
                                <button class="cc53" (click)="gotoGolfPlz(obj, $event)">{{'Golfplatz' }}</button>
                                }
                                @if(obj.isGolfHotels) {
                                <button class="cc53" (click)="gotoGolfHotel(obj, $event)">{{'Golfhotel' }}</button>
                                }
                                @if(obj.isJtHotels) {
                                <button class="cc53" (click)="gotoJtHotel(obj, $event)">{{'JT-Hotel' }}</button>
                                }
                            </div>
                        </button>
                    </ng-container>
                </div>
                <div class="cc50footer">
                    <button class="wbtn" (click)="gotoSearch($event)" matRipple>{{'weitere Ergebnisse anzeigen'
                        }}</button>
                </div>
            </ng-container>
        </div>
    </ng-template>
</ng-template>


<ng-template #myloading>
    <mat-spinner [diameter]="22"></mat-spinner>
</ng-template>

<ng-template #notfound>
    <div class="cc54">{{'Keine Ergebnisse gefunden' }}</div>
</ng-template>